//应用配置
module.exports = {
  appTitle: "先进典型",
  ossUrl: "https://politics-yun.oss-cn-hangzhou.aliyuncs.com/",
  // apiPath: "http://10.10.0.66:12135", //佘志彭
  apiPath:'https://xjdx-api.jsjc.gov.cn',
  apiToken:'3ae4c8f7f96dc88813c0aa8c0a2988e1',
};
